import { Fancybox } from '@fancyapps/ui';
import Swiper from 'swiper';
import { Navigation, Keyboard, A11y, Pagination, Autoplay } from 'swiper/modules';
import 'virtual-select-plugin/dist/virtual-select.min.js'

// window.Alpine = Alpine
// Alpine.start()

window.Swiper = Swiper
window.Navigation = Navigation
window.Keyboard = Keyboard
window.A11y = A11y
window.Pagination = Pagination
window.Autoplay = Autoplay
window.Fancybox = Fancybox

import algolia from './algolia';
import dropzone from './dropzone';


/**
 *
 */
document.addEventListener("DOMContentLoaded", function() {
    window.algolia = algolia;
    console.log(window.algolia);

    // Initialize dropzone functionality
    dropzone();
});


/**
 * Fancybox
 */


Fancybox.bind('[data-fancybox]', {
	Carousel : {
		infinite: false
	}
});


/**
 *
 */
document.addEventListener('keydown', function (event) {
    // Check for CMD+K (Mac) or CTRL+K (Windows)
    if ((event.metaKey || event.ctrlKey) && event.key === 'k') {
        event.preventDefault(); // Prevent default browser behavior

        console.log('CMD/CTRL + K detected');
        // Dispatch Livewire event to open modal
        window.Livewire.dispatchTo('product.search-modal', 'openModal', ['algolia', [], 'livewire', 'Search Products']);
    }
});


